import { render, staticRenderFns } from "./Listado.vue?vue&type=template&id=16784c04&"
import script from "./Listado.vue?vue&type=script&lang=ts&"
export * from "./Listado.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports